import '../typings'
import {
    isNaturalProfileAttributeLocked,
    NaturalProfile,
    TaxResidency,
} from '../utilities/account/useAccountDataPersonal'
import {
    LegalProfileAttribute,
    LegalProfileDocumentRequirements,
    LegalProfileDocumentType,
    NaturalProfileAttribute,
    NaturalProfileDocumentRequirements,
    NaturalProfileDocumentType,
} from '../typings'
import { LegalProfile } from '../utilities/account/useAccountDataLegal'
import { getPlatformSettings } from '../utilities/usePlatformSettings'

export function requiredNaturalProfileAttributesForInvestment(): NaturalProfileAttribute[] {
    return window.condaRequiredNaturalProfileAttributesForInvestment
}

export function requiredNaturalProfileAttributes(): NaturalProfileAttribute[] {
    return window.condaRequiredNaturalProfileAttributes
}

export function requiredLegalProfileAttributesForInvestment(): LegalProfileAttribute[] {
    return window.condaRequiredLegalProfileAttributesForInvestment
}

export function requiredLegalProfileAttributes(): LegalProfileAttribute[] {
    return window.condaRequiredLegalProfileAttributes
}

function requiredNaturalProfileDocuments(): NaturalProfileDocumentRequirements {
    return window.condaRequiredNaturalProfileDocuments
}

function requiredLegalProfileDocuments(): LegalProfileDocumentRequirements {
    return window.condaRequiredLegalProfileDocuments
}

export function isRequiredRequiredNaturalProfileAttributes(key: keyof NaturalProfile): boolean {
    return requiredNaturalProfileAttributes().includes(key) || isComplianceProfileRequiredNaturalProfileAttribute(key)
}

export function isRequiredNaturalProfileAttributesForInvestment(key: keyof NaturalProfile): boolean {
    return requiredNaturalProfileAttributesForInvestment().includes(key)
}

export function isRequiredRequiredLegalProfileAttributes(key: keyof LegalProfile): boolean {
    return requiredLegalProfileAttributes().includes(key) || isComplianceProfileRequiredLegalProfileAttribute(key)
}

export function isRequiredLegalProfileAttributesForInvestment(key: keyof LegalProfile): boolean {
    return requiredLegalProfileAttributesForInvestment().includes(key)
}

export function isNaturalProfileAttributeHidden(key: keyof NaturalProfile): boolean {
    return window.condaNaturalProfileAttributeHidden.includes(key)
}

export function isLegalProfileAttributeHidden(key: keyof LegalProfile): boolean {
    return window.condaLegalProfileAttributeHidden.includes(key)
}

export function isVisibleNaturalProfileDocuments(key: NaturalProfileDocumentType): boolean {
    return window.condaVisibleNaturalProfileDocuments.includes(key)
}

export function isVisibleLegalProfileDocuments(key: LegalProfileDocumentType): boolean {
    return window.condaVisibleLegalProfileDocuments.includes(key)
}

export function showRequired1Notice(): boolean {
    return window.condaShowRequired1Notice
}

export function showRequired2Notice(): boolean {
    return window.condaShowRequired2Notice
}

export function condaShowEmailChangeNotice(): boolean {
    return window.condaShowEmailChangeNotice
}

export function isRequiredNaturalProfileDocuments(key: keyof NaturalProfileDocumentRequirements): boolean {
    return (
        Object.prototype.hasOwnProperty.call(requiredNaturalProfileDocuments(), key) &&
        requiredNaturalProfileDocuments()[key] === true
    )
}

export function isRequiredLegalProfileDocuments(key: keyof LegalProfileDocumentRequirements): boolean {
    return (
        Object.prototype.hasOwnProperty.call(requiredLegalProfileDocuments(), key) &&
        requiredLegalProfileDocuments()[key] === true
    )
}

function isComplianceProfileRequiredNaturalProfileAttribute(key: keyof NaturalProfile) {
    const esacRequired = [
        'date_of_birth',
        'nationality',
        'country_of_birth',
        'city_of_birth',
        'gender',
        'pep',
        'pep_past',
        'address',
        'postal_code',
        'city',
        'country',
        'postal_address',
        'postal_address_postal_code',
        'postal_address_city',
        'postal_address_country',
    ]
    return (
        getPlatformSettings().compliance_profile === 'esac' &&
        esacRequired.includes(key) &&
        !isNaturalProfileAttributeLocked(key)
    )
}

function isComplianceProfileRequiredLegalProfileAttribute(key: keyof LegalProfile) {
    const esacRequired = [
        'registration_number',
        'legal_form',
        'registration_authority',
        'address',
        'postal_code',
        'city',
        'country',
    ]
    return getPlatformSettings().compliance_profile === 'esac' && esacRequired.includes(key)
}

export const getFieldRulesNatural = (
    key: keyof NaturalProfile,
    additionalRules = [],
    validateInvestmentRequired = false
): string => {
    const rules = []
    if (isNaturalProfileAttributeLocked(key)) {
        return ''
    }
    if (
        isComplianceProfileRequiredNaturalProfileAttribute(key) ||
        isRequiredRequiredNaturalProfileAttributes(key) ||
        (isRequiredNaturalProfileAttributesForInvestment(key) && validateInvestmentRequired)
    ) {
        rules.push('required')
    }
    return Array.from(new Set(rules.concat(additionalRules))).join('|')
}

export const getFieldRulesLegal = (
    key: keyof LegalProfile,
    additionalRules = [],
    validateInvestmentRequired = false
): string => {
    const rules = []
    if (
        isComplianceProfileRequiredLegalProfileAttribute(key) ||
        isRequiredRequiredLegalProfileAttributes(key) ||
        (isRequiredLegalProfileAttributesForInvestment(key) && validateInvestmentRequired)
    ) {
        rules.push('required')
    }
    return Array.from(new Set(rules.concat(additionalRules))).join('|')
}

export function clearIncompleteTaxResidencies(tax_residencies: TaxResidency[]) {
    return tax_residencies.filter((residency) => {
        return (
            residency.country &&
            residency.country !== '' &&
            ((residency.no_tin_reason && residency.no_tin_reason !== '') || (residency.tin && residency.tin !== ''))
        )
    })
}

export * from './rules'
